module.exports = __webpack_public_path__ + "img/patient.d4825884.png";